// What the overview charts are drawn from: things counted by week, and clean axis numbers. Plain JavaScript so node can test it
// without a browser.

const DAY = 86400000;

/** Midnight (UTC) on the Monday of the week a moment falls in. */
export function weekStart(ms) {
  const date = new Date(ms);
  const sinceMonday = (date.getUTCDay() + 6) % 7;
  return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() - sinceMonday);
}

/** "13 Oct" for the week starting then. */
const weekLabel = (start) => new Date(start).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', timeZone: 'UTC' });

/**
 * The last `weeks` weeks up to `now`, oldest first, each `{ start, label, counts }`: how many of each list of times (by key) fall
 * in that week. Times are anything `Date.parse` reads, or milliseconds; ones outside the weeks, or unreadable, are left out.
 */
export function countByWeek(lists, { weeks, now = Date.now() }) {
  const first = weekStart(now) - (weeks - 1) * 7 * DAY;
  const buckets = Array.from({ length: weeks }, (_, index) => {
    const start = first + index * 7 * DAY;
    return { start, label: weekLabel(start), counts: Object.fromEntries(Object.keys(lists).map((key) => [key, 0])) };
  });
  for (const [key, times] of Object.entries(lists)) {
    for (const time of times) {
      const ms = typeof time === 'number' ? time : Date.parse(time);
      if (Number.isNaN(ms)) continue;
      const index = Math.floor((weekStart(ms) - first) / (7 * DAY));
      if (index >= 0 && index < weeks) buckets[index].counts[key] += 1;
    }
  }
  return buckets;
}

/** Axis numbers from 0 to at least `max` in steps of 1, 2 or 5 × 10ⁿ, about `target` steps: 0, 5, 10, 15 for 13. */
export function niceTicks(max, target = 4) {
  const top = Math.max(1, Number(max) || 0);
  const rough = top / target;
  const power = 10 ** Math.floor(Math.log10(rough));
  const step = Math.max(1, [1, 2, 5, 10].map((multiple) => multiple * power).find((candidate) => candidate >= rough));
  const ticks = [];
  for (let tick = 0; tick < top + step; tick += step) ticks.push(tick);
  return ticks;
}
